import { Component, PropTypes } from 'react';
import cx from 'classnames';
import styles from './styles.css';

export default class Ad extends Component {
	static propTypes = {
		tag: PropTypes.string.isRequired,
		className: PropTypes.string
	}

	render() {
		return (
			<div className={cx(styles.ad, this.props.className)}>
				<div id={this.props.tag} />
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Ad/index.js
 **/